<template>
  <div class="d-flex-100 align-content-start" id="bdayCol" v-if="showForm" :class="extraWrapperClass">
    <div class="d-flex justify-content-between align-items-center">
      <div class="db-100 customer-panel-ttl">Bday4U</div>
      <i v-if="isSmallScreen" :class="chevronIcon" @click="toggleContentVisibility"></i>
    </div>
    <div v-if="isContentVisible">
      <p class="db-100">{{ t('birthday.static.text') }}</p>
      <div class="d-flex-100" id="submitBday">
        <input type="date" v-model="birthDay">
        <button v-on:click="formSubmit()" type="button">{{ t('entry.lbl') }}</button>
        <div v-if="showError" class="alert alert-error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BirthdayForm',
  props: {
    extraWrapperClass: {
      type: String,
      default: ''
    },
    hasBirthday: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      birthDay: '',
      formPosted: false,
      showError: false,
      error: '',
      isContentVisible: true
    }
  },
  computed: {
    showForm () {
      if (this.hasBirthday) {
        return false
      }
      return !this.formPosted
    },
    chevronIcon () {
      return this.isContentVisible ? 'lni lni-chevron-up' : 'lni lni-chevron-down'
    },
    isSmallScreen () {
      return window.innerWidth <= 500
    }
  },
  methods: {
    toggleContentVisibility () {
      this.isContentVisible = !this.isContentVisible
    },
    formSubmit () {
      if (!this.validateDate()) {
        this.error = this.t('birthday.emptyField')
        this.showError = true
        return
      }

      this.postData()
    },
    validateDate () {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      if (!regex.test(this.birthDay)) {
        return false
      }

      const date = new Date(this.birthDay)
      return !isNaN(date.getTime())
    },
    postData () {
      axios
        .post('/api/customer/addBirthDay', { date: this.birthDay })
        .then((response) => {
          this.formPosted = true
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.date
            this.showError = true
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>

  #bdayCol{
    padding:40px 55px;
    background: url("../img/bdayIcon.png") no-repeat 95% 20% #A2E2E0;
    color:var(--prime1);
    height: 100%;
    @media (max-width:767px), (min-width:992px) and (max-width:1199px){
      padding:20px;
      background: #A2E2E0
    }
    .customer-panel-ttl{
      font-size: 39px;
      font-weight: 900;
      @media screen and (min-width:768px) and (max-width:1199px){
        font-size: 27px
      }
      @media screen and (max-width:767px){
        font-size: 17px;
        font-weight: 800
      }
    }
    .customer-panel-ttl, p{
      flex:0 0 72%;
      max-width: 72%;
      line-height: 1.3;
      @media (max-width:767px), (min-width:992px) and (max-width:1199px){
        flex:0 0 100%;
        max-width: 100%
      }
    }
    p{
      line-height: 1.3;
      margin:0 0 25px 0;
      font-weight: 500;
      @media screen and (min-width:992px) and (max-width:1199px){
        font-size: 14px
      }
    }
    @media screen and (max-width: 500px) {
      .lni {
        position: absolute;
        top: 20px;
        right: 15px;
        font-size: 20px;
      }
    }
  }
  #submitBday{
    height:48px;
    // @media screen and (min-width:1200px){
    //   gap: 10px;
    // }
    input[type="date"]{
      margin-right:15px;
      border:1px solid #000;
      background-color: #fff;
      height:48px;
      flex:0 0 60%;
      max-width:60%;
      padding-left: 5px;
      @media screen and (min-width:1200px) and (max-width:1399px){
        // flex: 0 0 40%;
        // max-width: 40%;
        padding-left: 15px
      }
    }
    [type="date"] {
      background: url(../img/calendar_icon_gray_b_form.webp) calc(100% - 10px) center no-repeat #fff;
      position: relative;
      appearance: none
    }
    // works only on Chrome
    [type="date"]::-webkit-inner-spin-button {
      display: none;
      opacity: 0;
    }
    [type="date"]::-webkit-calendar-picker-indicator {
      opacity: 0;
      display:none
    }
    button{
      background:#000;
      color:#fff;
      border:0;
      padding:0 10px;
      height:48px;
      flex:0 0 35%;
      max-width:35%;
      // margin-left:auto;
    }
    @media (max-width:400px), (min-width:992px) and (max-width:1199px){
      input[type="date"]{
        flex:0 0 53%;
        max-width: 53%;
        margin-right:0
      }
      button{
        flex:0 0 47%;
        max-width: 47%;
        font-size:14px
      }
    }
  }
  // homepage logged in user overrides
  .home-info-user-mods-col {
    #bdayCol{
      position: relative;
      @media screen and (min-width:1200px) and (max-width:1399px){
        padding:15px
      }
      #submitBday{
        input[type="date"]{
          margin-right:0
        }
        button{
          flex:0 0 calc(35% + 15px);
          max-width:calc(35% + 15px);
          margin-left:0
        }
      }
    }
  }
</style>
